import axiosInstance from "../components/api/axiosInstance";

/**
 * Fetch user stories for a project or subproject.
 * @param {number} projectId - Project ID
 * @param {number|null} subProjectId - Subproject ID (null for project-level stories)
 * @returns {Promise<Array>} Array of user stories
 */
export async function fetchUserStories(projectId, subProjectId = null) {
  const params = { project_id: projectId };
  if (subProjectId != null && subProjectId !== undefined) {
    params.sub_project_id = subProjectId;
  }
  const response = await axiosInstance.get("/user-stories", { params });
  const raw = response.data;
  if (Array.isArray(raw)) return raw;
  if (raw?.data && Array.isArray(raw.data)) return raw.data;
  if (raw?.user_stories && Array.isArray(raw.user_stories)) return raw.user_stories;
  return [];
}

/**
 * Fetch a single user story by ID.
 * @param {number} userStoryId - User Story ID
 * @returns {Promise<Object>} User story object
 */
export async function fetchUserStoryById(userStoryId) {
  const response = await axiosInstance.get(`/user-stories/${userStoryId}`);
  return response.data?.data ?? response.data;
}

/**
 * Create a new user story.
 * @param {Object} payload - { Project_Id, Sub_Project_Id?, Title, Description, Status, Created_By }
 * @returns {Promise<Object>} Created user story
 */
export async function createUserStory(payload) {
  const response = await axiosInstance.post("/user-story", payload);
  return response.data?.data ?? response.data;
}

/**
 * Update a user story.
 * @param {number} userStoryId - User Story ID
 * @param {Object} payload - { Project_Id, Sub_Project_Id?, Title, Description, Status, Priority?, Updated_By }
 * @returns {Promise<Object>} Updated user story
 */
export async function updateUserStory(userStoryId, payload) {
  const response = await axiosInstance.put(`/user-story/${userStoryId}`, payload);
  return response.data?.data ?? response.data;
}

/**
 * Delete a user story.
 * @param {number} userStoryId - User Story ID
 * @returns {Promise<Object>} Response with message
 */
export async function deleteUserStory(userStoryId) {
  const response = await axiosInstance.delete(`/delete-user-story/${userStoryId}`);
  return response.data;
}
